import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from "@angular/router";

@Component({
  selector: 'app-clima-widget',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './clima-widget.component.html',
  styleUrls: ['./clima-widget.component.scss']
})
export class ClimaWidgetComponent implements OnInit {

  longitude: any;
  latitude: any;
  WeatherData: any;
  loading: boolean = false;

  constructor(private router: Router) { }

  ngOnInit() {
    this.WeatherData = {
      main: {},
      isDay: true
    };

    const savedData = localStorage.getItem('weatherData');
    if (savedData) {
      this.WeatherData = JSON.parse(savedData);
    } else {
      this.getWeatherData();
    }

    setInterval(() => {
      this.checkFetchData();
    }, 3600000);
  }

  checkFetchData() {
    const currentTime = Date.now();
    const lastCall = localStorage.getItem('lastWeatherCall');

    if (lastCall && (currentTime - parseInt(lastCall) < 3600000)) {
      console.log('Usando dados em cache');
      return;
    }

    this.getWeatherData();
    localStorage.setItem('lastWeatherCall', currentTime.toString());
  }

  getWeatherData() {
    if (!this.loading) {
      this.loading = true;
      fetch('https://api.openweathermap.org/data/2.5/weather?lat=-23.6164&lon=-46.5680&appid=bed73a3ce46105c67d6eef10c69fcde9')
        .then(response => response.json())
        .then(data => {
          this.setWeatherData(data);
          localStorage.setItem('weatherData', JSON.stringify(data));
          this.loading = false;
        })
        .catch(error => {
          console.error('Erro ao buscar dados:', error);
          this.loading = false;
        });
    }
  }

  setWeatherData(data: any) {
    this.WeatherData = data;
    let sunsetTime = new Date(this.WeatherData.sys.sunset * 1000);
    this.WeatherData.sunset_time = sunsetTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    let sunriseTime = new Date(this.WeatherData.sys.sunrise * 1000);
    this.WeatherData.sunrise_time = sunriseTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    console.log('Sunrise:', this.WeatherData.sunrise_time);
    console.log('Sunset:', this.WeatherData.sunset_time);
    let currentDate = new Date();
    this.WeatherData.isDay = (currentDate.getTime() < sunsetTime.getTime());
    this.WeatherData.temp_celcius = (this.WeatherData.main.temp - 273.15).toFixed(0);
    this.WeatherData.temp_min = (this.WeatherData.main.temp_min - 273.15).toFixed(0);
    this.WeatherData.temp_max = (this.WeatherData.main.temp_max - 273.15).toFixed(0);
    this.WeatherData.temp_feels_like = (this.WeatherData.main.feels_like - 273.15).toFixed(0);

    localStorage.setItem('weatherData', JSON.stringify(this.WeatherData));
    localStorage.setItem('lastWeatherCall', Date.now().toString());
  }
}
